module.exports = __webpack_public_path__ + "static/media/bariol_medium.a950708e1e5e935edf97f88caf51c0e20034879730b6f37cd9e50f6b0825df99.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/bariol_medium.ttf
// module id = 2547
// module chunks = 204